import { Badge, useMediaQuery } from '@mui/material';
import { Button } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { IoFilterSharp } from 'react-icons/io5';
import { Drawer } from 'src/components/shared/Drawer';

type FilterDrawerBodyProps = {
	filterApplied: boolean;
	showFilterDrawer: boolean;
	setShowFilterDrawer: React.Dispatch<React.SetStateAction<boolean>>;
	setFilterApplied: React.Dispatch<React.SetStateAction<boolean>>;
};

type FilterDrawerProps = {
	disabled?: boolean;
	inactive?: boolean;
	onClose?: () => void;
	filterDrawerBody: (props: FilterDrawerBodyProps) => React.ReactElement;
	filterDrawerHeader: React.ReactElement;
	filterDrawerFooter?: React.ReactElement;
	filterAppliedValue?: boolean;
};

const FilterDrawer = ({
	onClose,
	disabled,
	inactive,
	filterDrawerBody,
	filterDrawerHeader,
	filterDrawerFooter,
	filterAppliedValue,
}: FilterDrawerProps) => {
	const [filterApplied, setFilterApplied] = useState(false);
	const [showFilterDrawer, setShowFilterDrawer] = useState(false);
	const isMobile = useMediaQuery('(max-width:960px)');

	useEffect(() => {
		if (filterAppliedValue !== undefined) setFilterApplied(filterAppliedValue);
	}, [filterAppliedValue]);

	return (
		<>
			<Badge
				badgeContent={''}
				color="primary"
				invisible={!filterApplied}
				sx={{
					'& .MuiBadge-badge': {
						height: '10px',
						minWidth: '10px',
						width: '10px',
						padding: '0px',
					},
				}}
			>
				<Button
					disabled={disabled}
					onClick={() => {
						if (inactive) {
							return;
						}
						setShowFilterDrawer(true);
					}}
					className="walkthrough-third-element text-[#1C1C28] rounded-[8px] p-[8px] [&>span]:!p-0"
					color="light"
				>
					<IoFilterSharp className="w-[24px] h-[24px]" />
				</Button>
			</Badge>

			{/* Filters Drawer */}
			<Drawer
				minHeight={'max-content'}
				borderRadius={isMobile ? '16px 16px 0px 0px' : '0px'}
				minWidth={!isMobile ? '390px' : '100%'}
				maxWidth={!isMobile ? '390px' : '100%'}
				maxHeight={isMobile ? '80dvh' : '100dvh'}
				backDropColor={isMobile ? 'rgba(0, 0, 0, 0.5)' : 'transparent'}
				boxShadow="0px -8px 32px 0px #00000040"
				position={isMobile ? 'bottom' : 'right'}
				isOpen={showFilterDrawer}
				onClose={() => {
					setShowFilterDrawer(false);
					onClose && onClose();
				}}
				header={filterDrawerHeader}
				body={
					filterDrawerBody &&
					filterDrawerBody({ filterApplied, showFilterDrawer, setShowFilterDrawer, setFilterApplied })
				}
				footer={filterDrawerFooter}
			/>
		</>
	);
};

export default FilterDrawer;
